export const MARGIN_DOC_TYPES = ["Quote", "Order", "Invoice"];

// Cost per unit for margin: the line's snapshot cost, else the item card's current cost.
const unitCost = (l, items) => Number(l.unit_cost || 0) || Number(items.find((x) => x.id === l.item_id)?.cost || 0);

// Margin % on a line (sale converted to AUD with the doc's rate, since item costs are in AUD); null when not an item line.
export const lineMargin = (l, items, rateToAud = 1) => {
  if (!l.item_id) { return null; }
  const sale = Number(l.quantity || 0) * Number(l.unit_price || 0) * (rateToAud || 1);
  if (sale <= 0) { return null; }
  return ((sale - Number(l.quantity || 0) * unitCost(l, items)) / sale) * 100;
};

export const docMargin = (lines, items, rateToAud = 1) => {
  let sale = 0;
  let cost = 0;
  (lines || []).forEach((l) => {
    if (!l.item_id) { return; }
    sale += Number(l.quantity || 0) * Number(l.unit_price || 0) * (rateToAud || 1);
    cost += Number(l.quantity || 0) * unitCost(l, items);
  });
  return sale > 0 ? { pct: ((sale - cost) / sale) * 100, profit: sale - cost } : null;
};

export const MarginBadge = ({ pct, threshold, testid }) => {
  if (pct === null || pct === undefined) { return <span className="text-muted-foreground">—</span>; }
  const low = pct < threshold;
  return (
    <span className={`tabular text-xs font-semibold ${low ? "text-red-600" : "text-emerald-700"}`} data-testid={testid} title={low ? `Below the ${threshold}% low-margin threshold` : ""}>
      {pct.toFixed(1)}%
    </span>
  );
};
